"use strict";

exports.__esModule = true;
var _exportNames = {
  Add: true,
  AddOne: true,
  Attention: true,
  Calendar: true,
  Check: true,
  CheckOne: true,
  CheckSmall: true,
  Close: true,
  CloseDrawer: true,
  CloseOne: true,
  CloseSmall: true,
  Cutting: true,
  DoubleLeft: true,
  DoubleRight: true,
  Down: true,
  DownOne: true,
  Drag: true,
  Edit: true,
  Filter: true,
  FullScreen: true,
  FullScreenOne: true,
  HamburgerButton: true,
  Help: true,
  Inbox: true,
  Info: true,
  Left: true,
  LeftC: true,
  Loading: true,
  Minus: true,
  More: true,
  People: true,
  Plus: true,
  PreviewOpen: true,
  RadioUncheck: true,
  Redo: true,
  ReduceOne: true,
  Right: true,
  RightC: true,
  RightOne: true,
  Search: true,
  Time: true,
  ToTopOne: true,
  Up: true,
  UpOne: true,
  Upload: true,
  UploadOne: true,
  ViewList: true,
  Delete: true,
  SwitchOn: true,
  SwitchOff: true,
  ZoomIn: true,
  ZoomOut: true,
  OneToOne: true,
  Rotate: true,
  Frame: true
};
exports.Frame = exports.Rotate = exports.OneToOne = exports.ZoomOut = exports.ZoomIn = exports.SwitchOff = exports.SwitchOn = exports.Delete = exports.ViewList = exports.UploadOne = exports.Upload = exports.UpOne = exports.Up = exports.ToTopOne = exports.Time = exports.Search = exports.RightOne = exports.RightC = exports.Right = exports.ReduceOne = exports.Redo = exports.RadioUncheck = exports.PreviewOpen = exports.Plus = exports.People = exports.More = exports.Minus = exports.Loading = exports.LeftC = exports.Left = exports.Info = exports.Inbox = exports.Help = exports.HamburgerButton = exports.FullScreenOne = exports.FullScreen = exports.Filter = exports.Edit = exports.Drag = exports.DownOne = exports.Down = exports.DoubleRight = exports.DoubleLeft = exports.Cutting = exports.CloseSmall = exports.CloseOne = exports.CloseDrawer = exports.Close = exports.CheckSmall = exports.CheckOne = exports.Check = exports.Calendar = exports.Attention = exports.AddOne = exports.Add = void 0;

var _types = require("./types");

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  exports[key] = _types[key];
});

var _add = _interopRequireDefault(require("./components/add"));

exports.Add = _add.default;

var _addOne = _interopRequireDefault(require("./components/addOne"));

exports.AddOne = _addOne.default;

var _attention = _interopRequireDefault(require("./components/attention"));

exports.Attention = _attention.default;

var _calendar = _interopRequireDefault(require("./components/calendar"));

exports.Calendar = _calendar.default;

var _check = _interopRequireDefault(require("./components/check"));

exports.Check = _check.default;

var _checkOne = _interopRequireDefault(require("./components/checkOne"));

exports.CheckOne = _checkOne.default;

var _checkSmall = _interopRequireDefault(require("./components/checkSmall"));

exports.CheckSmall = _checkSmall.default;

var _close = _interopRequireDefault(require("./components/close"));

exports.Close = _close.default;

var _closeDrawer = _interopRequireDefault(require("./components/closeDrawer"));

exports.CloseDrawer = _closeDrawer.default;

var _closeOne = _interopRequireDefault(require("./components/closeOne"));

exports.CloseOne = _closeOne.default;

var _closeSmall = _interopRequireDefault(require("./components/closeSmall"));

exports.CloseSmall = _closeSmall.default;

var _cutting = _interopRequireDefault(require("./components/cutting"));

exports.Cutting = _cutting.default;

var _doubleLeft = _interopRequireDefault(require("./components/doubleLeft"));

exports.DoubleLeft = _doubleLeft.default;

var _doubleRight = _interopRequireDefault(require("./components/doubleRight"));

exports.DoubleRight = _doubleRight.default;

var _down = _interopRequireDefault(require("./components/down"));

exports.Down = _down.default;

var _downOne = _interopRequireDefault(require("./components/downOne"));

exports.DownOne = _downOne.default;

var _drag = _interopRequireDefault(require("./components/drag"));

exports.Drag = _drag.default;

var _edit = _interopRequireDefault(require("./components/edit"));

exports.Edit = _edit.default;

var _filter = _interopRequireDefault(require("./components/filter"));

exports.Filter = _filter.default;

var _fullScreen = _interopRequireDefault(require("./components/fullScreen"));

exports.FullScreen = _fullScreen.default;

var _fullScreenOne = _interopRequireDefault(require("./components/fullScreenOne"));

exports.FullScreenOne = _fullScreenOne.default;

var _hamburgerButton = _interopRequireDefault(require("./components/hamburgerButton"));

exports.HamburgerButton = _hamburgerButton.default;

var _help = _interopRequireDefault(require("./components/help"));

exports.Help = _help.default;

var _inbox = _interopRequireDefault(require("./components/inbox"));

exports.Inbox = _inbox.default;

var _info = _interopRequireDefault(require("./components/info"));

exports.Info = _info.default;

var _left = _interopRequireDefault(require("./components/left"));

exports.Left = _left.default;

var _leftC = _interopRequireDefault(require("./components/leftC"));

exports.LeftC = _leftC.default;

var _loading = _interopRequireDefault(require("./components/loading"));

exports.Loading = _loading.default;

var _minus = _interopRequireDefault(require("./components/minus"));

exports.Minus = _minus.default;

var _more = _interopRequireDefault(require("./components/more"));

exports.More = _more.default;

var _people = _interopRequireDefault(require("./components/people"));

exports.People = _people.default;

var _plus = _interopRequireDefault(require("./components/plus"));

exports.Plus = _plus.default;

var _previewOpen = _interopRequireDefault(require("./components/previewOpen"));

exports.PreviewOpen = _previewOpen.default;

var _radioUncheck = _interopRequireDefault(require("./components/radioUncheck"));

exports.RadioUncheck = _radioUncheck.default;

var _redo = _interopRequireDefault(require("./components/redo"));

exports.Redo = _redo.default;

var _reduceOne = _interopRequireDefault(require("./components/reduceOne"));

exports.ReduceOne = _reduceOne.default;

var _right = _interopRequireDefault(require("./components/right"));

exports.Right = _right.default;

var _rightC = _interopRequireDefault(require("./components/rightC"));

exports.RightC = _rightC.default;

var _rightOne = _interopRequireDefault(require("./components/rightOne"));

exports.RightOne = _rightOne.default;

var _search = _interopRequireDefault(require("./components/search"));

exports.Search = _search.default;

var _time = _interopRequireDefault(require("./components/time"));

exports.Time = _time.default;

var _toTopOne = _interopRequireDefault(require("./components/toTopOne"));

exports.ToTopOne = _toTopOne.default;

var _up = _interopRequireDefault(require("./components/up"));

exports.Up = _up.default;

var _upOne = _interopRequireDefault(require("./components/upOne"));

exports.UpOne = _upOne.default;

var _upload = _interopRequireDefault(require("./components/upload"));

exports.Upload = _upload.default;

var _uploadOne = _interopRequireDefault(require("./components/uploadOne"));

exports.UploadOne = _uploadOne.default;

var _viewList = _interopRequireDefault(require("./components/viewList"));

exports.ViewList = _viewList.default;

var _delete = _interopRequireDefault(require("./components/delete"));

exports.Delete = _delete.default;

var _switchOn = _interopRequireDefault(require("./components/switchOn"));

exports.SwitchOn = _switchOn.default;

var _switchOff = _interopRequireDefault(require("./components/switchOff"));

exports.SwitchOff = _switchOff.default;

var _zoomIn = _interopRequireDefault(require("./components/zoomIn"));

exports.ZoomIn = _zoomIn.default;

var _zoomOut = _interopRequireDefault(require("./components/zoomOut"));

exports.ZoomOut = _zoomOut.default;

var _oneToOne = _interopRequireDefault(require("./components/oneToOne"));

exports.OneToOne = _oneToOne.default;

var _rotate = _interopRequireDefault(require("./components/rotate"));

exports.Rotate = _rotate.default;

var _frame = _interopRequireDefault(require("./components/frame"));

exports.Frame = _frame.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }